<h4 class="secondary-header">Maquinaria</h4>
<form [formGroup]="equipamientoFormGroup">
  <div formArrayName="maquinas" *ngFor="let m of maquinas().controls; let mIndex=index">
    <div [formGroupName]="mIndex">
      <div class="row">
        <mat-form-field class="col"
          *ngIf="(this.tiposEquipamientoProcesamiento$ | async) as tiposEquipamientoProcesamiento">
          <mat-label>Tipo de máquina: </mat-label>
          <mat-select formControlName="tipo_equipamiento_procesamiento_id" required>
            <mat-option *ngFor="let tep of tiposEquipamientoProcesamiento" [value]="tep.id">
              {{tep.nombre}}
            </mat-option>
            <mat-option [value]="0">
              Otro
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col" *ngIf="m.get('tipo_equipamiento_procesamiento_id').value == 0">
          <input matInput placeholder="Nombre:" required formControlName="tipo_equipamiento_procesamiento_nombre">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <input matInput placeholder="Marca:" required formControlName="marca">
        </mat-form-field>
        <mat-form-field class="col-6">
          <input matInput placeholder="Modelo" required formControlName="modelo">
        </mat-form-field>
      </div>
      <!--<div class="row" >
        <mat-form-field class="col-6">
          <input matInput placeholder="Número precinto INASE:" formControlName="n_precinto">
        </mat-form-field>
        <mat-form-field class="col-6">
          <input matInput placeholder="GPS" formControlName="gps">
        </mat-form-field>
      </div> -->
      <div>
        <button *ngIf="maquinas().length > 1" type="button" mat-stroked-button (click)="eliminarMaquina(mIndex)"
          color="warn" matTooltip="Eliminar maquina">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
          <span>Eliminar máquina</span>
        </button>
      </div>
    </div>
  </div>
  <div>
    <button type="button" (click)="agregarMaquina()" mat-stroked-button color="primary"
      matTooltip="Agregar nueva maquina">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
      <span>Agregar nueva máquina</span>
    </button>
  </div>
</form>